@if (useStandard) {
  <crm-standard-single-select
    [descriptorApiUrl]="descriptorUrl"
    [selectedValue]="selectedMasterMilestone"
    (selectedValueChange)="onSelected($event)"
    [class]="class"
    [styleClass]="styleClass"
    [showClear]="showClear"
    [disabled]="disabled"
    [isError]="isError"
    [appendTo]="appendTo"
    [placeholder]="placeholder"></crm-standard-single-select>
} @else {
  <crm-single-select
    [options]="masterMilestones"
    [selectedItem]="selectedMasterMilestone"
    (selectedItemChange)="onSelected($event)"
    [showClear]="showClear"
    [styleClass]="styleClass"
    [class]="class"
    [appendTo]="appendTo"
    [disabled]="disabled"
    [isError]="isError"
    [loading]="loading"
    [placeholder]="placeholder"></crm-single-select>
}
